import React, { Fragment, PureComponent } from 'react'
import track from 'react-tracking'
import { myaccountPageData } from '../analytics'
import StoreCredit from './StoreCredit'
import GiftCards from './GiftCards'

@track({})
class Credits extends PureComponent {
    @track(
        myaccountPageData({
            name: 'store credit',
            type: 'store credit page',
            subCategory1: 'store credit',
        })
    )
    componentDidMount() {}

    render() {
        const { enableGiftCards } = this.props
        return (
            <Fragment>
                {enableGiftCards && <GiftCards {...this.props} />}
                <StoreCredit {...this.props} />
            </Fragment>
        )
    }
}

export default Credits
